'use client';

import { useImpersonation } from '@/contexts/ImpersonationContext';
import { X, UserCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function ImpersonationBanner() {
  const { isImpersonating, impersonatedUser, stopImpersonation } = useImpersonation();

  if (!isImpersonating || !impersonatedUser) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-purple-600 text-white px-4 py-2" data-testid="impersonation-banner">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <UserCheck className="h-4 w-4" />
          <span className="text-sm font-medium" data-testid="current-user">
            Impersonating: {impersonatedUser.displayName || impersonatedUser.email || 'User'}
          </span>
          {impersonatedUser.orgRole && (
            <span className="px-2 py-1 bg-purple-700 rounded text-xs">
              {impersonatedUser.orgRole}
            </span>
          )}
        </div>

        <Button
          variant="ghost"
          size="sm"
          onClick={stopImpersonation}
          className="text-white hover:bg-purple-700"
          data-testid="stop-impersonation"
        >
          <X className="h-4 w-4 mr-1" />
          Stop Impersonating
        </Button>
      </div>
    </div>
  );
}